export default `
	badge
	headline,
	headlineTop,
	paragraph {
		content
	}
`;
